module.exports = __webpack_public_path__ + "static/media/banano5.f31b1bdc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/banano/banano5.jpeg
// module id = 41
// module chunks = 0